/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsType from '@jira/spa-apps__servicedesk-reports/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReports: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskReportsType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-reports", jiraSpaEntry: "async-servicedesk-reports" */ '@jira/spa-apps__servicedesk-reports/src/index.tsx'
		),
);
type Props = RouteContext;

/**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */

const AsyncServicedeskReports = ({ match }: Props): React.JSX.Element => {
	return (
		<LazyPage
			Page={LazyServicedeskReports}
			pageId={`spa-apps/servicedesk/reports/${match ? match.url : ''}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReports;
